import {  deleteProduct } from "api/Customers";
import { queryClient } from "lib/helpers/configs/queryClient";
import { useMutation } from "react-query";
import { toast } from "react-toastify";

export const useDeleteProducts = () => {
  return useMutation(deleteProduct, {
    onSuccess: () => {
      queryClient.invalidateQueries("customerProducts");
      queryClient.invalidateQueries("coustomers");

      toast.success("Deleted Successfully");
    },
    onError: (error: any) => {
      if(error.response.data.message){
        toast.error(error.response.data.message);
      }else if(error.response.data.error){
        toast.error(error.response.data.error);
      }else{
        toast.error("Something went wrong, please try again later.");
      }
    },
  });
};
